(function ($) {
  DJ.addBehavior('governanceDropDown', '.governance-list__levels', {
    attach: function () {
      const list = this;
      const items = list.querySelectorAll('.governance-item');
      const calcHeightClass = 'governance-item-dropdown--calc-height';
      const openedClass = 'governance-item--opened';
      const elementsArr = Array.prototype.slice.call(items);
      const itemDrop = list.querySelectorAll('.governance-item-dropdown');

      if (!items.length) {
        return;
      }

      const getPageTopPadding = () => {
        const body = $('body');
        let headerHeight = $('.header--sticky-view').outerHeight();

        if (body.hasClass('toolbar-fixed')) {
          headerHeight += 39;
        }

        if (body.hasClass('toolbar-horizontal') && body.hasClass('toolbar-tray-open')) {
          headerHeight += 40;
        }

        return headerHeight;
      };

      /**
       * Close dropdown.
       * @param element
       *  Element object.
       * @param item
       *  Element object.
       */
      const closeDropDown = (element, item) => {
        const dropDown = element;
        dropDown.style.height = '';
        item.classList.remove(openedClass);
        dropDown.classList.remove('scroll');
        item.classList.add('no-scroll');
        item.classList.remove('no-scroll');
      };

      /**
       * Close all opened dropdowns.
       */
      const closeAllDropDowns = () => {
        elementsArr.forEach((e) => {
          const dropDownToClose = e.querySelector('.governance-item-dropdown');

          if (!dropDownToClose) {
            return;
          }

          if (e.classList.contains(openedClass)) {
            closeDropDown(dropDownToClose, e);
          }
        });
      };

      /**
       * Open dropdown.
       * @param element
       *  Element object.
       * @param item
       *  Element object.
       */
      const openDropDown = (element, item) => {
        const dropDown = element;

        closeAllDropDowns();

        // Calculate the height and width for the dropdown.
        dropDown.classList.add(calcHeightClass);
        item.classList.add(openedClass);
        dropDown.style.width = `${list.offsetWidth}px`;
        dropDown.classList.add('scroll');

        const dropDownHeight = dropDown.offsetHeight;

        dropDown.classList.remove(calcHeightClass);

        // Set the height and left position.
        setTimeout(() => {
          dropDown.style.height = `${dropDownHeight}px`;
          const leftPosition = item.getBoundingClientRect().left
            - list.getBoundingClientRect().left;
          dropDown.style.left = `-${leftPosition}px`;
        }, 0);
        setTimeout(() => {
          $('html, body').animate({
            scrollTop: $('.scroll').offset().top - getPageTopPadding() - 20
          }, 500);
        }, 800);
      };

      // Bind open/close events.
      elementsArr.forEach((e) => {
        const dropDown = e.querySelector('.governance-item-dropdown');
        const clickZone = e.querySelector('.governance-item__inner');
        const buttonClose = e.querySelector('.governance-item-dropdown__close');

        if (!dropDown || !clickZone || !buttonClose) {
          return;
        }

        clickZone.style.height = `${clickZone.offsetHeight}px`;

        clickZone.addEventListener('click', () => {
          if (e.classList.contains(openedClass)) {
            closeDropDown(dropDown, e);
          } else {
            openDropDown(dropDown, e);
          }
        });

        buttonClose.addEventListener('click', () => {
          closeDropDown(dropDown, e);
        });
      });

      // Close all dropdowns on resize.
      window.addEventListener('resize', () => {
        closeAllDropDowns();

        // Recalculate items height to have equal per row.
        elementsArr.forEach((e) => {
          const clickZone = e.querySelector('.governance-item__inner');

          if (!clickZone) {
            return;
          }

          setTimeout(() => {
            clickZone.style.height = '';

            setTimeout(() => {
              clickZone.style.height = `${clickZone.offsetHeight}px`;
            }, 0);
          }, 1000);
        });
      });
    }
  });
})(jQuery);
